import useMediaQuery from '@mui/material/useMediaQuery';

import { BreakpointName, mediaDown, mediaUp, MEDIA_TOUCH } from '@styles/theme';

// Input-aware breakpoint checks: these match the exact compound media queries
// emitted by theme.down()/theme.up(), so JS layout decisions stay in sync with
// the JSS styles (fine pointers switch layout at lower widths than coarse ones).
export const useBreakpointDown = (breakpoint: BreakpointName): boolean =>
    useMediaQuery(mediaDown(breakpoint));

export const useBreakpointUp = (breakpoint: BreakpointName): boolean =>
    useMediaQuery(mediaUp(breakpoint));

// The primary input is touch — matches the CSS coarse branch exactly.
export const useIsCoarsePointer = (): boolean => useMediaQuery(MEDIA_TOUCH);

// Touch tablets up to ~11" in landscape (10.9" iPad Air landscape = 1180px CSS
// viewport). Bigger slates (11"+ in landscape: 1194px and up) have enough room
// for desktop-style side-by-side layouts.
export const useIsCoarseTablet = (): boolean =>
    useMediaQuery('(pointer: coarse) and (max-width: 1180px)');

// The device has ANY touch capability (including touch-laptops with a mouse).
// Use for behavioral decisions, not layout switching.
export const useIsTouchDevice = (): boolean => {
    const isCoarsePointer = useIsCoarsePointer();

    return isCoarsePointer || (typeof navigator !== 'undefined' && (navigator.maxTouchPoints ?? 0) > 0);
};
